import styled from 'styled-components';
import { Link } from 'react-router-dom';

const StyledLink = styled(Link)`
  margin: 10px;
  text-decoration: none;
`;

export default StyledLink;
